import {
  CLUSTER_ROUTES as toolConfigClusterRoutes,
  TOOL_CLUSTERS as toolConfigClusters,
  TOOL_DEFINITIONS as toolConfigDefinitions,
} from '@repo/studio-tool-config/tool-definitions'
import type {
  ToolCluster as StudioToolConfigCluster,
  ToolDefinition as StudioToolConfigDefinition,
} from '@repo/studio-tool-config/tool-definitions'

export const TOOL_CLUSTERS = toolConfigClusters
export const CLUSTER_ROUTES = toolConfigClusterRoutes
export const TOOL_DEFINITIONS = toolConfigDefinitions

export type ToolCluster = StudioToolConfigCluster
export type ToolDefinition = StudioToolConfigDefinition
